import { LinearProgress, Stack } from "@mui/material";
import { DataGrid, DataGridProps, GridSlots } from "@mui/x-data-grid";
import { deDE, enUS, frFR, itIT } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/*
 * Notes:
 * 1. Using Flex parent container to avoid use autoHeight https://mui.com/x/react-data-grid/layout/#flex-parent-container
 */

// MUI DataGrid's own built-in strings (pagination footer, menus) per UI language.
// MUI ships no Romansh (rm) bundle, so rm falls back to enUS below.
const DATA_GRID_LOCALES: Record<string, typeof enUS> = {
  de: deDE,
  fr: frFR,
  it: itIT,
};

type SuperDataGridProps = DataGridProps & {
  noRowsOverlayText?: string;
  autoCacheRowCount?: boolean;
  for: string;
};

export const SuperDataGrid = ({
  noRowsOverlayText,
  autoCacheRowCount = true,
  ...props
}: SuperDataGridProps) => {
  const { t, i18n } = useTranslation();
  const localeText = (DATA_GRID_LOCALES[i18n.resolvedLanguage ?? ""] ?? enUS)
    .components.MuiDataGrid.defaultProps.localeText;
  /*
   * rowCount must be set if not paginationModel will reset,
   * because rowCount almost don't change we can cache it
   */
  const { rowCount, ...rest } = props;
  const [rowCountCache, setRowCountCache] = useState(0);

  useEffect(() => {
    if (props.rowCount) {
      setRowCountCache(props.rowCount);
    }
  }, [props]);

  return (
    <DataGrid
      className={`SuperDataGrid__${props.for}`}
      slots={{
        loadingOverlay: LinearProgress as GridSlots["loadingOverlay"],
        noRowsOverlay: () => (
          <Stack alignItems="center" justifyContent="center" marginTop="30px">
            {noRowsOverlayText ?? t("components.noData")}
          </Stack>
        ),
      }}
      localeText={localeText}
      rowHeight={40}
      columnHeaderHeight={40}
      rowCount={autoCacheRowCount ? rowCountCache : rowCount}
      {...rest}
    />
  );
};
